import React from 'react';
const OnlineLearning = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Online Learning</h1>
          <div className="w-24 h-1 bg-primary mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-4xl mx-auto">
            Flexible, high-quality education that fits your schedule, from anywhere in the world.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {/* Feature 1 */}
          <div className="bg-white p-6 rounded-lg shadow-md text-center">
            <div className="text-4xl mb-4">🎓</div>
            <h3 className="text-xl font-semibold mb-2">Fully Accredited</h3>
            <p className="text-gray-600">Same prestigious degree as on-campus students</p>
          </div>
          
          {/* Feature 2 */}
          <div className="bg-white p-6 rounded-lg shadow-md text-center">
            <div className="text-4xl mb-4">⏱️</div>
            <h3 className="text-xl font-semibold mb-2">Flexible Schedule</h3>
            <p className="text-gray-600">Study at your own pace, 24/7 access</p>
          </div>
          
          {/* Feature 3 */}
          <div className="bg-white p-6 rounded-lg shadow-md text-center">
            <div className="text-4xl mb-4">🌍</div>
            <h3 className="text-xl font-semibold mb-2">Global Classroom</h3>
            <p className="text-gray-600">Join students from around the world</p>
          </div>
        </div>

        <div className="bg-white p-8 rounded-lg shadow-lg">
          <h2 className="text-2xl font-semibold mb-6">Available Online Programs</h2>
          <div className="space-y-4">
            {[
              'Bachelor of Computer Science',
              'MBA in Digital Marketing',
              'Master of Education',
              'Bachelor of Business Administration',
              'Master of Data Science'
            ].map((program, index) => (
              <div key={index} className="flex justify-between items-center p-4 hover:bg-gray-50 rounded-md">
                <span className="text-lg">{program}</span>
                <button className="text-primary hover:underline">View Program</button>
              </div>
            ))}
          </div>
        </div>
      </div>
      
    </div>
  );
};

export default OnlineLearning;
